export enum ContractionIntensity {
  MILD = 'mild',
  MODERATE = 'moderate',
  STRONG = 'strong',
  VERY_STRONG = 'very strong',
}

export enum ContractionRestingTone {
  SOFT = 'soft',
  FIRM = 'firm',
  HYPERTONIC = 'hypertonic',
}

export interface Contraction {
  frequency: number
  duration: number
  intensity: ContractionIntensity
  restingTone: ContractionRestingTone
  collectedVia: 'manual' | 'instrument'
  notes?: string
}
